import { render, staticRenderFns } from "./PageModeratorFeatureAdd.vue?vue&type=template&id=d40728c6&"
import script from "./PageModeratorFeatureAdd.vue?vue&type=script&lang=js&"
export * from "./PageModeratorFeatureAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
